import type { PickingInfo } from '@deck.gl/core';
import type { DetailGridItem } from '../../shared/components';
import { FrontendGeoJsonFeature, HouseholdGroup } from '../../types/global';

export type MarkerObject = FrontendGeoJsonFeature | HouseholdGroup;

type MarkerPosition = Omit<PickingInfo<MarkerObject>, 'object'> & {
  shouldOpenLeft?: boolean,
  shouldOpenUp?: boolean,
};

export type ClickedMarker = MarkerPosition & (
  | { kind: 'household'; object: HouseholdGroup }
  | { kind: 'ward'; object: FrontendGeoJsonFeature }
);

export const HouseholdCardStatusValues = {
  Loading: 'loading',
  Error: 'error',
  Loaded: 'loaded',
} as const;

export type HouseholdCardDetail =
  | { status: typeof HouseholdCardStatusValues.Loading }
  | { status: typeof HouseholdCardStatusValues.Error, message: string }
  | { status: typeof HouseholdCardStatusValues.Loaded, items: DetailGridItem[] };
